import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Toaster } from "sonner";

import { NoMobileSupportMessage } from "./NoMobileSupportMessage";
import { ReferAFriendDialog } from "./ReferAFriendDialog";
import { MediaFullscreenProvider } from "./ui/MediaBlocks";
import { CommandMenuProvider } from "./UnifiedRegistry/CommandMenu";
import DialogProvider from "./UnifiedRegistry/Dialogs";
import { withUnifiedRegistryStore } from "./UnifiedRegistry/unified-registry-context";

import { InvitationDialogStacks } from "@/components/InvitationDialogStacks";
import { PaymentIssueLoginDialog } from "@/components/PaymentIssueLoginDialog";
import { RemixHandler } from "@/components/RemixHandler";
import { SkillRemixHandler } from "@/components/SkillRemixHandler";
import SidebarSearchLayout from "@/components/SidebarSearchLayout";
import UserChannelProvider from "@/components/UserChannelProvider";
import { useFollowMode } from "@/components/VibeChat/hooks/useFollowMode";
import { MfaVerificationProvider } from "@/context/mfa-verification-context";
import { UserProvider } from "@/context/user-context";
import useActiveWorkspace from "@/hooks/useActiveWorkspace";
import { OrganizationSubscriptionProvider } from "@/providers/OrganizationSubscriptionProvider";
import { LLMProviderStoreProvider } from "@/providers/ProviderAndModelsProvider";
import { RbacProvider } from "@/providers/RbacProvider";
import { WorkspaceAccessGuard } from "@/routes/guards/WorkspaceAccessGuard";
import { TOASTER_CONFIG } from "@/utils/toaster-config";

const SidebarSearchLayoutWrapperContent = () => {
  const workspace = useActiveWorkspace();
  const [isReferralDialogOpen, setIsReferralDialogOpen] = useState(false);
  useFollowMode();
  if (workspace === null) {
    return (
      <div className="flex h-screen flex-col bg-background">
        <div className="border-b border-border/50 px-6 py-3">
          <div className="h-4 w-40 rounded bg-muted/50" />
        </div>
        <div className="flex min-h-0 flex-1">
          <div className="w-16 border-r border-border/40 bg-muted/20" />
          <div className="min-h-0 flex-1 p-4">
            <div className="h-full rounded-md border border-border/60 bg-muted/20" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <RbacProvider>
      <CommandMenuProvider>
        <UserChannelProvider>
          <DialogProvider>
            <LLMProviderStoreProvider>
              <OrganizationSubscriptionProvider>
                <MfaVerificationProvider>
                  <PaymentIssueLoginDialog />
                  <MediaFullscreenProvider>
                    <SidebarSearchLayout>
                      <NoMobileSupportMessage />
                      <ReferAFriendDialog
                        setIsOpen={setIsReferralDialogOpen}
                        isOpen={isReferralDialogOpen}
                      />
                      <Outlet />
                      <Toaster {...TOASTER_CONFIG} />
                      <InvitationDialogStacks />
                      <RemixHandler />
                      <SkillRemixHandler />
                    </SidebarSearchLayout>
                  </MediaFullscreenProvider>
                </MfaVerificationProvider>
              </OrganizationSubscriptionProvider>
            </LLMProviderStoreProvider>
          </DialogProvider>
        </UserChannelProvider>
      </CommandMenuProvider>
    </RbacProvider>
  );
};

const SidebarSearchLayoutWrapper = () => (
  <UserProvider>
    <WorkspaceAccessGuard>
      <SidebarSearchLayoutWrapperContent />
    </WorkspaceAccessGuard>
  </UserProvider>
);

export default withUnifiedRegistryStore(SidebarSearchLayoutWrapper);
